/* istanbul ignore file */
import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { AutoTestStepValidationException } from './AutoTestStepValidationException';
import { BaseError } from './BaseError';
import { DisabledSettingException } from './DisabledSettingException';
import { FailedToSendEmailException } from './FailedToSendEmailException';
import { FirstPhaseLTILaunchException } from './FirstPhaseLTILaunchException';
import { GroupNotReadyForSubmissionException } from './GroupNotReadyForSubmissionException';
import { IgnoredFilesException } from './IgnoredFilesException';
import { InvalidGroupException } from './InvalidGroupException';
import { InvalidIOCasesException } from './InvalidIOCasesException';
import { InvalidOptionsException } from './InvalidOptionsException';
import { MissingCookieError } from './MissingCookieError';
import { ParseAPIException } from './ParseAPIException';
import { PermissionException } from './PermissionException';
import { RepositoryConnectionLimitReachedException } from './RepositoryConnectionLimitReachedException';
import { TokenRevokedException } from './TokenRevokedException';
import { UpgradedLTIProviderException } from './UpgradedLTIProviderException';
import { WeakPasswordException } from './WeakPasswordException';
const AnyErrorParser = /* #__PURE__ */ /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ codecOneOf([
    IgnoredFilesException,
    DisabledSettingException,
    InvalidIOCasesException,
    PermissionException,
    FailedToSendEmailException,
    GroupNotReadyForSubmissionException,
    WeakPasswordException,
    ParseAPIException,
    InvalidGroupException,
    AutoTestStepValidationException,
    RepositoryConnectionLimitReachedException,
    TokenRevokedException,
    MissingCookieError,
    InvalidOptionsException,
    UpgradedLTIProviderException,
    FirstPhaseLTILaunchException,
    BaseError,
]));
export const AnyError = AnyErrorParser;
